<template>
  <div class="is-loggin">
    <h3 class="title-main">Mi Escritorio</h3>
    <div id="login-trigger" @click="toggleMenu()">
      <div class="profile-img"></div>
      <span class="label icon icon-chevron-down"></span>
    </div>
    <div
      id="user-menu"
      style="display: block"
      :class="dropdown ? 'open' : 'none'"
    >
      <div class="user-menu-container">
        <span class="arrow"></span>
        <div class="user-menu-bg">
          <div class="menu-nav">
            <span
              id="login-closer-btn"
              @click="toggleMenu()"
              class="icon icon-cancel"
            ></span>
          </div>
          <div class="data-resume">
            <div class="data-resume-title">¡Hola!</div>
            <div class="data-resume-email">
              {{ user.username }}
            </div>
          </div>
          <div class="menu">
            <div id="logout" class="menu-item">
              <router-link to="/login" class="close-session"
                >Cerrar sesión</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
export default {
data() {
    return {
      user: {},
      dropdown: false,
    };
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    
  },
  methods: {
    toggleMenu() {
      this.dropdown = !this.dropdown;
      document
        .querySelector(".label.icon.icon-chevron-down")
        .classList.toggle("rotate");
    },
  }
}
</script>

<style lang="scss">

@import "../../core/core-framework/assets/scss/inc/mixins/_text_mixins.scss";
@import "../../core/core-framework/assets/scss/inc/_variables.scss";
@import "../../core/core-framework/assets/scss/inc/_bootstrap_custom_variables.scss";
@import "../../core/core-framework/assets/scss/inc/mixins/mixins";
@import "../../core/core-framework/assets/scss/inc/_buttons";
@import "../../core/core-framework/assets/scss/inc/_shadows.scss";
.is-loggin {
margin-bottom: -57px;
}
.title-main {
    @include text(
      $size: 32px,
      $weight: 600,
      $color: $color-white,
      $lineheight: 1.13
    );
    position: relative;
    z-index: 2;
    top: -109px;
    text-align: center;
    cursor: default;
  }
#login-trigger {
  display: flex;
  position: relative;
  top: -175px;
  right: 100px;
  z-index: 2;
  float: right;
  cursor: pointer;
  .label {
    @include text($size: 16px, $color: $color-white);
    @include position($position: relative, $top: 3px, $left: 10px);
    transition: all 0.2s ease;
    transform: none;
    &.rotate {
      transform: rotate(-180deg);
      top: -1px;
    }
    @media screen and (min-width: $screen-md) {
      top: 10px;
      &.rotate {
        top: -8px;
      }
    }
  }
}
.profile-img {
  background-image: url(../assets/generic-user.svg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  height: 40px;
  width: 40px;
  border-radius: 50%;
}
#user-menu {
  top: 0;
  position: relative;
  .user-menu-container {
    top: -87px;
    right: 99px;
    position: absolute;
    overflow: hidden;
    text-align: center;
    transition: all 0.2s ease-in-out;
    opacity: 0;
    display: inline-block;
    width: 270px;
    max-height: 0;
    z-index: 2;
    .user-menu-bg {
      border-radius: 4px;
      background: $color-blue-02;
      overflow: hidden;
      position: relative;
      z-index: 1;
      top: -20px;
      transition: all 0.2s ease-in-out;
      &::after {
        top: -390px;
        width: 120%;
        height: 507px;
        position: absolute;
        min-width: 590px;
        left: 50%;
        transform: translateX(-50%);
        content: "";
        z-index: -1;
        border-radius: 50%;
        background: $color-blue-02h;
      }
      .menu-nav {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 16px 0;
        .icon {
          font-size: 24px;
          color: $color-grey-02;
          line-height: 1em;
          cursor: pointer;
          opacity: 1;
          transition: opacity 0.5s ease-out;
          color: $color-white;
          top: 12px;
          right: 16px;
          position: absolute;
          &::before {
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-style: normal;
            font-variant: normal;
            font-weight: 400;
            text-decoration: none;
            text-transform: none;
          }
          &.is-hidden {
            visibility: hidden;
            pointer-events: none;
            opacity: 0;
          }
          &.icon-arrow-left {
            height: 20px;
            overflow: hidden;
            &::before {
              content: "<";
            }
          }
        }
        .login-closer-btn {
          color: $color-white;
          position: relative;
          font-size: 21px;
          top: -8px;
          left: 232px;
          cursor: pointer;
          font-weight: 600;
          z-index: 2;
        }
      }
      .data-resume {
        font-weight: 400;
        color: $color-white;
        margin-top: 16px;
        .data-resume-title {
          font-size: 18px;
          line-height: 26px;
        }
        .data-resume-email {
          font-size: 14px;
          line-height: 18px;
        }
      }
      .menu {
        width: 185px;
        margin: 24px auto auto;
        list-style: none;
        -webkit-padding-start: 0;
        padding-inline-start: 0;
        padding: 16px;
        font-size: 14px;
        font-weight: 500;
        line-height: 18px;
        .menu-item {
          display: flex;
          padding: 10px 32px;
          text-align: left;
          align-items: center;
          cursor: pointer;
          color: $color-white;
          .close-session {
            color: $color-white;
            text-decoration: underline;
          }
        }
      }
    }
  }
  &.open {
    display: block;
    .user-menu-container {
      max-height: 600px;
      opacity: 1;
    }
  }
  .arrow {
    display: block;
    height: 28px;
    width: 100%;
    position: relative;
    &::before {
      right: 32px;
      bottom: 9px;
      position: absolute;
      content: "";
      border: 8px solid transparent;
      border-top-color: $color-blue-02h;
      border-left-color: $color-blue-02h;
      transform: rotate(45deg);
    }
  }
}
</style>